// extracted by mini-css-extract-plugin
export default {"phoneDial":"PhoneDialButton_phoneDial__tdObG","phoneIcon":"PhoneDialButton_phoneIcon__u0Jcz","phoneText":"PhoneDialButton_phoneText__0I1Cu"};